import { gql } from '@apollo/client';

export const ChangeTimeZone = gql`
    mutation changeTimeZone($timeZone: String!, $agentId: ID!) {
        changeTimeZone(timeZone: $timeZone, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
